import React from "react";
import useAppUpdateCheck from "../hooks/useAppUpdateCheck";

/**
 * Tells an already-open tab that a newer build is live on S3 and offers a
 * reload. Deliberately plain DOM + inline styles: it must render correctly
 * even if the app's theme providers are not mounted yet.
 */
const AppUpdateBanner = () => {
  const { updateAvailable, reload } = useAppUpdateCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 12,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2147483647,
        display: "flex",
        alignItems: "center",
        gap: 12,
        maxWidth: "92vw",
        padding: "10px 14px",
        borderRadius: 10,
        backgroundColor: "rgba(17, 24, 39, 0.97)",
        border: "1px solid rgba(255,255,255,0.15)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
        A new version is available
      </span>
      <button
        type="button"
        onClick={reload}
        style={{
          border: "none",
          cursor: "pointer",
          borderRadius: 8,
          padding: "6px 12px",
          fontSize: 12,
          fontWeight: 700,
          color: "#fff",
          backgroundColor: "rgba(232, 108, 0, 1)",
        }}
      >
        Reload
      </button>
    </div>
  );
};

export default AppUpdateBanner;
